module.exports = __webpack_public_path__ + "img/drop-photo.c02bbf2e.svg";